<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Detail {{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name: table_module}">{{module}}</router-link>
              </li>
              <li class="breadcrumb-item active">detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <ul class="nav nav-tabs align-items-center flex-wrap">
      <li class="nav-item">
        <a :class="'nav-link ' + (openTab == 'detail' ? 'active' : '')"
          href="javascript:void(0)" @click="changeTab('detail')">Detail</a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (openTab == 'history' ? 'active' : '')"
          href="javascript:void(0)" @click="changeTab('history')">History Transaksi</a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (openTab == 'log_stok' ? 'active' : '')"
          href="javascript:void(0)" @click="changeTab('log_stok')">History Stok</a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (openTab == 'log_harga_beli' ? 'active' : '')"
          href="javascript:void(0)" @click="changeTab('log_harga_beli')">History Harga Beli</a>
      </li>
      <li class="nav-item">
        <a :class="'nav-link ' + (openTab == 'log_harga_jual' ? 'active' : '')"
          href="javascript:void(0)" @click="changeTab('log_harga_jual')">History Harga Jual</a>
      </li>
      <li class="ml-auto d-flex align-items-center" style="padding-bottom:2px; gap:6px">
        <button class="btn btn-sm btn-outline-warning" @click="openAdjust('harga_beli')">
          <i class="mdi mdi-pencil mr-1"></i>Ubah Harga Beli
        </button>
        <button class="btn btn-sm btn-outline-primary" @click="openAdjust('harga_jual')">
          <i class="mdi mdi-pencil mr-1"></i>Ubah Harga Jual
        </button>
        <router-link class="btn btn-sm btn-info" :to="{name: table_module+'_edit', params:{uuid}}">
          <i class="mdi mdi-pencil-outline mr-1"></i>Edit
        </router-link>
        <button class="btn btn-sm btn-danger" @click="confirmDelete">
          <i class="mdi mdi-trash-can-outline mr-1"></i>Hapus
        </button>
      </li>
    </ul>

    <div class="row" v-if="dataLoad && openTab == 'detail'">
      <div class="col-xs-12 col-sm-4">
        <div class="card p-0">
          <div class="product-detai-imgs text-center">
            <div class="tab-content" id="v-pills-tabContent" v-if="data.prd_image.length > 0">
              <div
                v-for="(item, index) in data.prd_image" :key="index"
                :class="'tab-pane fade show '+ (index == 0 ? 'active' : '')"
                :id="'product-'+index"
                role="tabpanel"
                :aria-labelledby="'product-'+index+'-tab'"
              >
                <div>
                  <img
                    :src="$root.backEnd+item['prd_r_img_name']"
                    :alt="item['prd_r_img_name']"
                    class="img-fluid mx-auto d-block"
                  />
                </div>
              </div>
            </div>
            <div class="tab-content" id="v-pills-tabContent" v-else>
              <div
                class="'tab-pane fade show active"
                id="product-0"
                role="tabpanel"
                aria-labelledby="product-0-tab"
              >
                <div>
                  <img
                    src="@/assets/images/error-img.png"
                    alt="no image"
                    class="img-fluid mx-auto d-block"
                  />
                </div>
              </div>
            </div>
            <div
              class="nav nav-pills row m-auto w-100"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
              v-for="(item, index) in data.prd_image" :key="index"
                :class="'nav-link col-3 '+ (index == 0 ? 'active' : '')"
                :id="'product-'+index+'-tab'"
                data-toggle="pill"
                :href="'#product-'+index"
                role="tab"
                :aria-controls="'product-'+index"
                aria-selected="true"
              >
                <img
                  :src="$root.backEnd+item['prd_r_img_name']"
                  :alt="item['prd_r_img_name']"
                  class="img-fluid mx-auto d-block rounded"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-8">
        <div class="card min-h-350">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <div class="media-body overflow-hidden">
                <p class="text-muted mb-2">{{data.prd_sku}}</p>
                <h5 class="text-truncate font-size-20">{{data.prd_name}}</h5>
              </div>
            </div>

            <h5 class="font-size-15 mt-4">Description</h5>
            <p class="text-muted mb-4">{{(data.prd_description != null) ? data.prd_description : ''}}</p>

            <div class="table-responsive">
              <table class="table table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Kategori</th>
                    <td>
                      <router-link :to="{name:'products_category_detail', params: { uuid: data.prd_c_uuid }}">{{ data.prd_c_name }}</router-link>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Brand</th>
                    <td>
                      <router-link :to="{name:'brand_detail', params: { uuid: data.brd_uuid }}">{{ data.brd_name }}</router-link>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Harga Beli</th>
                    <td>Rp {{ numberWithCommas(data.prd_price) }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Harga Jual</th>
                    <td>
                      <template v-if="data.prd_discount_active">
                        <span class="text-muted"><s>Rp {{ numberWithCommas(data.prd_purchase) }}</s></span>
                        <span class="text-danger font-weight-bold ml-2">Rp {{ numberWithCommas(data.prd_effective_price) }}</span>
                      </template>
                      <template v-else>
                        Rp {{ numberWithCommas(data.prd_purchase) }}
                      </template>
                    </td>
                  </tr>
                  <tr v-if="data.prd_discount_active">
                    <th scope="row">Diskon</th>
                    <td>
                      <span class="badge badge-danger p-1 mr-1">
                        {{ data.prd_discount_type === 'percentage' ? data.prd_discount_value + '%' : 'Rp ' + numberWithCommas(data.prd_discount_value) }}
                      </span>
                      <small class="text-muted">
                        {{ $moment(data.prd_discount_start).format('DD MMM') }} - {{ $moment(data.prd_discount_end).format('DD MMM YYYY') }}
                      </small>
                    </td>
                  </tr>
                  <tr v-if="data.prd_free_shipping == 1">
                    <th scope="row">Gratis Ongkir</th>
                    <td><span class="badge badge-success p-1">Ya</span></td>
                  </tr>
                  <tr>
                    <th scope="row">No Rak</th>
                    <td>{{data.prd_no_rak}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Stock</th>
                    <td>{{data.prd_stock+' '+data.prd_unit}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab History Transaksi -->
    <div class="row" v-if="openTab == 'history'">
      <div class="card col-12">
        <div class="card-body">
          <div class="align-items-center d-lg-flex d-none">
            <div class="form-group mb-0 align-items-center d-flex">
              <label class="mb-0">Show</label>
              <select class="form-control ml-3" v-model="show" @change="showLimit">
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
          <hr>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Tanggal</th>
                <th>Invoice</th>
                <th>Tipe Penjualan</th>
                <th>Harga Jual</th>
                <th>Jumlah</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, i) in transaksi.data" :key="i">
                <td>{{ $moment(d.transaksi_detail.transaksi.created_at).format('DD-MM-YYYY HH:mm:ss')}}</td>
                <td>
                  <router-link class="mr-1" target="_blank"
                    :to="{ name: 'services_transaction_detail', params: { uuid: d.transaksi_detail.transaksi.srv_t_uuid } }"
                  >{{ d.transaksi_detail.transaksi.srv_t_code }}</router-link>
                </td>
                <td>{{ d.srv_t_r_srv_b_id_ref != 0 ? 'Paket' : 'Produk' }}</td>
                <td>Rp. {{ d.srv_t_r_srv_b_id_ref != 0 ? 0 : numberWithCommas(d.prd_act_price) }}</td>
                <td>{{ d.prd_qty }}</td>
                <td>Rp. {{ d.srv_t_r_srv_b_id_ref != 0 ? 0 : numberWithCommas(d.prd_total_price) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-md-5">Anda memiliki {{ numberWithCommas(transaksi.total_transaksi) }} transaksi</div>
            <template v-if="transaksi.total_page != 0">
              <paginate
                v-model="page"
                :pageCount="parseInt(transaksi.total_page)"
                :initial-page="page"
                :click-handler="startPaginate"
                prevText="<i class='mdi mdi-chevron-left'></i>"
                nextText="<i class='mdi mdi-chevron-right'></i>"
                container-class="pagination pagination-rounded justify-content-end col-md-7"
                pageClass="page-item"
                page-link-class="page-link"
                prev-class="page-item"
                prev-link-class="page-link"
                next-class="page-item"
                next-link-class="page-link"
              ></paginate>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab History Stok -->
    <div class="row" v-if="openTab == 'log_stok'">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="font-size-15 mb-3">
              <i class="mdi mdi-transfer-down mr-1 text-success"></i>History Pergerakan Stok
            </h5>
            <div class="table-responsive">
              <table class="table table-bordered table-sm">
                <thead class="thead-light">
                  <tr>
                    <th>Tanggal</th>
                    <th class="text-center">Tipe</th>
                    <th class="text-center">Qty</th>
                    <th class="text-right">Stok Sebelum</th>
                    <th class="text-right">Stok Sesudah</th>
                    <th>Sumber</th>
                    <th>No. Referensi</th>
                    <th>Keterangan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="logs.stock_logs.length === 0">
                    <td colspan="8" class="text-center text-muted py-3">Belum ada history stok</td>
                  </tr>
                  <tr v-for="(log, i) in logs.stock_logs" :key="'sl-'+i">
                    <td>{{ $moment(log.created_at).format('DD-MM-YYYY HH:mm') }}</td>
                    <td class="text-center">
                      <span :class="log.psl_type == 1 ? 'badge badge-success' : 'badge badge-danger'">
                        {{ log.psl_type == 1 ? '▲ Masuk' : '▼ Keluar' }}
                      </span>
                    </td>
                    <td class="text-center font-weight-bold">{{ log.psl_qty }}</td>
                    <td class="text-right">{{ log.psl_stock_before }}</td>
                    <td class="text-right font-weight-bold">{{ log.psl_stock_after }}</td>
                    <td><span class="badge badge-secondary">{{ sourceLabel(log.psl_source) }}</span></td>
                    <td>
                      <router-link v-if="log.psl_ref_uuid" :to="refLink(log.psl_source, log.psl_ref_uuid)" class="text-primary">
                        {{ log.psl_ref_no || '-' }}
                      </router-link>
                      <span v-else>{{ log.psl_ref_no || '-' }}</span>
                    </td>
                    <td class="text-muted small">{{ log.psl_notes || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab History Harga Beli -->
    <div class="row" v-if="openTab == 'log_harga_beli'">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="font-size-15 mb-3">
              <i class="mdi mdi-tag-outline mr-1 text-warning"></i>History Perubahan Harga Beli
            </h5>
            <div class="table-responsive">
              <table class="table table-bordered table-sm">
                <thead class="thead-light">
                  <tr>
                    <th>Tanggal</th>
                    <th class="text-right">Harga Lama</th>
                    <th class="text-right">Harga Baru</th>
                    <th>Sumber</th>
                    <th>No. Referensi</th>
                    <th>Catatan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="priceLogs('harga_beli').length === 0">
                    <td colspan="6" class="text-center text-muted py-3">Belum ada history perubahan harga beli</td>
                  </tr>
                  <tr v-for="(log, i) in priceLogs('harga_beli')" :key="'pb-'+i">
                    <td>{{ $moment(log.created_at).format('DD-MM-YYYY HH:mm') }}</td>
                    <td class="text-right text-muted">Rp {{ numberWithCommas(log.ppl_price_before) }}</td>
                    <td class="text-right font-weight-bold">
                      <span :class="log.ppl_price_after > log.ppl_price_before ? 'text-danger' : 'text-success'">
                        Rp {{ numberWithCommas(log.ppl_price_after) }}
                      </span>
                    </td>
                    <td><span class="badge badge-secondary">{{ sourceLabel(log.ppl_source) }}</span></td>
                    <td>
                      <router-link v-if="log.ppl_ref_uuid" :to="refLink(log.ppl_source, log.ppl_ref_uuid)" class="text-primary">
                        {{ log.ppl_ref_no || '-' }}
                      </router-link>
                      <span v-else>{{ log.ppl_ref_no || '-' }}</span>
                    </td>
                    <td class="text-muted small">{{ log.ppl_notes || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab History Harga Jual -->
    <div class="row" v-if="openTab == 'log_harga_jual'">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="font-size-15 mb-3">
              <i class="mdi mdi-tag-text mr-1 text-primary"></i>History Perubahan Harga Jual
            </h5>
            <div class="table-responsive">
              <table class="table table-bordered table-sm">
                <thead class="thead-light">
                  <tr>
                    <th>Tanggal</th>
                    <th class="text-right">Harga Lama</th>
                    <th class="text-right">Harga Baru</th>
                    <th>Sumber</th>
                    <th>No. Referensi</th>
                    <th>Catatan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="priceLogs('harga_jual').length === 0">
                    <td colspan="6" class="text-center text-muted py-3">Belum ada history perubahan harga jual</td>
                  </tr>
                  <tr v-for="(log, i) in priceLogs('harga_jual')" :key="'pj-'+i">
                    <td>{{ $moment(log.created_at).format('DD-MM-YYYY HH:mm') }}</td>
                    <td class="text-right text-muted">Rp {{ numberWithCommas(log.ppl_price_before) }}</td>
                    <td class="text-right font-weight-bold">
                      <span :class="log.ppl_price_after > log.ppl_price_before ? 'text-success' : 'text-danger'">
                        Rp {{ numberWithCommas(log.ppl_price_after) }}
                      </span>
                    </td>
                    <td><span class="badge badge-secondary">{{ sourceLabel(log.ppl_source) }}</span></td>
                    <td>
                      <router-link v-if="log.ppl_ref_uuid" :to="refLink(log.ppl_source, log.ppl_ref_uuid)" class="text-primary">
                        {{ log.ppl_ref_no || '-' }}
                      </router-link>
                      <span v-else>{{ log.ppl_ref_no || '-' }}</span>
                    </td>
                    <td class="text-muted small">{{ log.ppl_notes || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Ubah Harga -->
    <b-modal v-model="adjust.show" :title="adjust.price_type === 'harga_beli' ? 'Ubah Harga Beli' : 'Ubah Harga Jual'" hide-footer>
      <div class="form-group">
        <label class="text-muted small">Harga saat ini</label>
        <p class="font-weight-bold font-size-16">
          Rp {{ adjust.price_type === 'harga_beli' ? numberWithCommas(data.prd_price) : numberWithCommas(data.prd_purchase) }}
        </p>
      </div>
      <div class="form-group">
        <label>Harga Baru <span class="text-danger">*</span></label>
        <input type="number" class="form-control" v-model="adjust.new_price" min="0" placeholder="Masukkan harga baru" />
      </div>
      <div class="form-group">
        <label>Catatan <span class="text-danger">*</span></label>
        <textarea class="form-control" v-model="adjust.notes" rows="3" placeholder="Alasan perubahan harga..."></textarea>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn-secondary mr-2" @click="adjust.show = false">Batal</button>
        <button class="btn btn-primary" @click="submitAdjust" :disabled="adjust.loading">
          <span v-if="adjust.loading"><i class="mdi mdi-loading mdi-spin mr-1"></i>Menyimpan...</span>
          <span v-else>Simpan</span>
        </button>
      </div>
    </b-modal>

  </div>
</template>

<script>

export default {
  data() {
    return {
      visible: false,
      show: 10,
      page: 1,
      isLoading: false,
      module: "Spare Part",
      table_module: "products",
      alias_table: "prd",
      uuid: this.$route.params.uuid,
      data: {},
      transaksi: {},
      dataSearch: {},
      dataLoad: false,
      openTab : 'detail',
      limit: 15,
      totalData: 0,
      logs: { stock_logs: [], price_logs: [] },
      adjust: {
        show: false,
        price_type: 'harga_beli',
        new_price: '',
        notes: '',
        loading: false,
      },
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
          this.dataLoad = true;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    fetchTransaksi(arm) {
      var params = {};
      if (typeof arm === 'undefined') {
        params = { page: this.page, show: this.show, order_by: this.orderBy, type_sort: this.sort };
      } else {
        params = {
          page: (arm.page == undefined) ? this.page : arm.page,
          show: (arm.show == undefined) ? this.show : arm.show,
          order_by: (arm.orderBy == undefined) ? this.orderBy : arm.orderBy,
          type_sort: (arm.sort == undefined) ? this.sort : arm.sort,
        };
      }

      this.isLoading = true;
      this.axios
        .get("/services_transaction/search-by-product/" + this.uuid, {params})
        .then((response) => {
          this.isLoading = false;
          this.transaksi = response.data.data;
          this.dataLoad = true;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    changeTab(tab){
      this.openTab = tab;
      if (tab == 'history') {
        this.fetchTransaksi();
      } else if (tab === 'log_stok' || tab === 'log_harga_beli' || tab === 'log_harga_jual') {
        if (this.logs.stock_logs.length === 0 && this.logs.price_logs.length === 0) {
          this.fetchLogs();
        }
      }
    },
    confirmDelete() {
      if (!confirm('Yakin ingin menghapus produk ini?')) return;
      this.isLoading = true;
      this.axios
        .post('/' + this.table_module + '/delete/' + this.uuid)
        .then(() => {
          this.isLoading = false;
          this.$toast.success('Produk berhasil dihapus');
          this.$router.push({ name: this.table_module });
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.error('Gagal menghapus produk');
        });
    },
    fetchLogs() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/logs/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.logs = response.data.data;
        })
        .catch(() => { this.isLoading = false; });
    },
    priceLogs(type) {
      return this.logs.price_logs.filter(l => (l.ppl_price_type || 'harga_beli') === type);
    },
    openAdjust(priceType) {
      this.adjust.price_type = priceType;
      this.adjust.new_price  = priceType === 'harga_beli' ? this.data.prd_price : this.data.prd_purchase;
      this.adjust.notes      = '';
      this.adjust.loading    = false;
      this.adjust.show       = true;
    },
    submitAdjust() {
      if (!this.adjust.new_price && this.adjust.new_price !== 0) {
        this.$toast.error("Harga baru wajib diisi");
        return;
      }
      if (!this.adjust.notes.trim()) {
        this.$toast.error("Catatan wajib diisi");
        return;
      }
      this.adjust.loading = true;
      this.axios
        .post("/" + this.table_module + "/adjust_price/" + this.uuid, {
          price_type: this.adjust.price_type,
          new_price : parseInt(this.adjust.new_price),
          notes     : this.adjust.notes,
        })
        .then((response) => {
          this.adjust.loading = false;
          this.adjust.show    = false;
          this.$toast.success(response.data.message || "Harga berhasil diperbarui");
          this.fetchDetail();
          if (this.logs.price_logs.length > 0) {
            this.fetchLogs();
          }
        })
        .catch((error) => {
          this.adjust.loading = false;
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Gagal menyimpan";
          this.$toast.error(msg);
        });
    },
    refLink(source, uuid) {
      if (!uuid) return '#';
      if (['pembelian_produk','pembelian_produk_edit','pembelian_produk_edit_rollback','pembelian_produk_delete'].includes(source)) {
        return { name: 'pembelian_produk_detail', params: { uuid } };
      }
      if (source === 'stock_opname') {
        return { name: 'stock_opname_detail', params: { uuid } };
      }
      if (source.startsWith('services_transaction')) {
        return { name: 'services_transaction_detail', params: { uuid } };
      }
      return '#';
    },
    sourceLabel(source) {
      const map = {
        'pembelian_produk'              : 'Pembelian',
        'pembelian_produk_edit'         : 'Edit PO',
        'pembelian_produk_edit_rollback': 'Edit PO (rollback)',
        'pembelian_produk_delete'       : 'Hapus PO',
        'services_transaction'          : 'Transaksi Servis',
        'services_transaction_rollback' : 'Edit Transaksi (rollback)',
        'services_transaction_cancel'   : 'Batal Transaksi',
        'adjustment'                    : 'Adjustment Manual',
        'manual'                        : 'Manual',
      };
      return map[source] || source;
    },
    qucikCreateShow(arm) {
      this.visible = arm;
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    startPaginate: function (pageNum) {
      var arm = { page: pageNum, show: parseInt(this.limit) };
      this.fetchTransaksi(arm);
    },
    showLimit() {
      this.page = 1;
      this.fetchTransaksi();
    },
  },
};
</script>
